<template>
  <div class="fifthPage">
    <div class="pageBody">
      <el-row :gutter="20" justify="center" align="middle" class="row">
        <el-col :span="8" class="col">
          <img src="/static/imgs/fifthPage/1.png">
        </el-col>
        <el-col :span="16" class="col">
          <img src="/static/imgs/fifthPage/2.png">
        </el-col>
      </el-row>
      <el-row :gutter="20" justify="center" align="middle" class="row">
        <el-col :span="8" class="col">
          <img src="/static/imgs/fifthPage/3.png">
        </el-col>
        <el-col :span="6" class="col">
          <span class="colWord">
            我们专注于通过沉浸式学习方法论为企业组织发展赋能。
          </span>
        </el-col>
        <el-col :span="10" class="col">
          <img src="/static/imgs/fifthPage/4.png">
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
export default {
  name: "fifthPage",
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.fifthPage {
  margin: 0 0 0px 0;
  background-color: whitesmoke;
  padding: 140px 0;
}
.pageBody {
  .row {
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .col {
      height: 100%;
      text-align: left;
      img {
        width: 100%;
      }
      .colWord {
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fifthPage.vue